// @ts-ignore
import InfiniteMarquee from 'vanilla-infinite-marquee';

export function initMarqueeAnimation() {
	if (!(window as any).marqueeInitialized) {
		(window as any).marqueeInitialized = true
	}
	const elements = document.querySelectorAll<HTMLElement>(
		'.marquee-init-animation'
	);

	elements?.forEach((element) => {
		new InfiniteMarquee({
			element,
			duplicateCount: 2,
			speed: element.dataset.speed,
			direction: element.dataset.direction,
			spaceBetween: `${element.dataset.space}px`,
			mobileSettings: {
				speed: element.dataset.mobileSpeed
			},
			on: {
				afterInit: () => {
					return element.style.opacity = '1'
				}
			}
		})
	})
}
